import { onDocumentReady } from '@theme/utilities';
/**
 * Appends the 'cid' query parameter from the current page URL
 * to newsletter subscription links with data-action="newsletter-subscribe"
 */
export function initNewsletterCidAppender() {
    // Get cid parameter from current page URL
    const urlParams = new URLSearchParams(window.location.search);
    const cid = urlParams.get('cid');

    if (!cid) return;

    // Function to append cid to a URL
    /**
     * @param {string} url
     * @param {string} cidValue
     * @returns {string}
     */
    function appendCidToUrl(url, cidValue) {
        if (!url) return url;

        // Avoid duplicates
        if (url.includes('cid=')) return url;

        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}cid=${encodeURIComponent(cidValue)}`;
    }

    // Listen for clicks on newsletter subscription links
    document.addEventListener(
        'click',
        (event) => {
            const target = event.target;
            if (!target) return;
            if (
                target instanceof HTMLAnchorElement &&
                target.getAttribute('data-action') == 'newsletter-subscribe'
            ) {
                const currentHref = target.getAttribute('href');

                if (currentHref) {
                    const updatedHref = appendCidToUrl(currentHref, cid);
                    target.setAttribute('href', updatedHref);
                }
            }
        },
        true,
    );
}

// Initialize newsletter CID appender when document is ready
onDocumentReady(initNewsletterCidAppender);
